module.exports = __webpack_public_path__ + "img/Yotta-login.171895.svg";